import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { NzCardModule } from 'ng-zorro-antd/card'

import { User } from '../../models/user.model'
import { CognitoService } from '../../services/cognito.service'

@Component({
  selector: 'app-start',
  standalone: true,
  imports: [TranslatePipe, NzCardModule, SvgIconComponent, RouterLink],
  templateUrl: './start.component.html',
})
export class StartComponent {
  public user?: User

  public constructor(private readonly cognitoService: CognitoService) {
    cognitoService.user.subscribe((user) => {
      this.user = user
    })
  }
}
